import React, { Component } from 'react';
import { TableHead, TableRow } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { connect } from 'react-redux';
import { ROLE_USER } from '../../constants/roles';

export class BookingsTableHead extends Component {
  state = {
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
    }
    return newState;
  }

  createSortHandler = property => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    const columnData = [
      {
        id: 'date', numeric: true, disablePadding: false, label: 'Date',
      },
      {
        id: 'nb_adult_bikes', numeric: true, disablePadding: false, label: 'Vélos adulte',
      },
      {
        id: 'nb_children_bikes', numeric: true, disablePadding: false, label: 'Vélos enfant',
      },
      {
        id: 'client_name', numeric: false, disablePadding: false, label: 'Client',
      },
    ];

    return (
      <TableHead>
        <TableRow>
          {columnData.map(column => (
            <TableCell
              key={column.id}
              padding={column.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === column.id ? order : false}>
              <Tooltip
                title="Trier"
                placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                enterDelay={300}>
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order === 'asc' ? 'desc' : 'asc'}
                  onClick={this.createSortHandler(column.id)}>
                  {column.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ), this)}
          <TableCell padding="checkbox">
          </TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
  };
}

export default connect(mapStateToProps)(BookingsTableHead);



// WEBPACK FOOTER //
// ./src/components/Bookings/BookingsTableHead.jsx